module.exports = __webpack_public_path__ + "static/img/zhuanti_bg.7caffaa7.png";